import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ height, theme }) => {
	const fillColor = theme === `dark` ? `#FFFFFF` : `#2D3134`;

	return (
		<svg
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			width="150px"
			viewBox="0 0 189 40"
			style={{ enableBackground: 'new 0 0 189 40' }}
			xmlSpace="preserve"
		>
			<title>0BA2BF95-0ED3-4D35-A8D2-345C03475D56@3x</title>
			<desc>Created with sketchtool.</desc>
			<g id="Website" className="st0">
				<g id="Appbase.io-_x2F_-Support" transform="translate(-198.000000, -663.000000)">
					<g
						id="Logo_Appbase"
						transform="translate(198.000000, 663.000000)"
						style={{ fill: fillColor }}
					>
						<g>
							<g id="Group-3" transform="translate(0.000000, 0.099455)">
								<g id="Clip-2" />
								<defs>
									<filter
										id="Adobe_OpacityMaskFilter"
										filterUnits="userSpaceOnUse"
										x="0"
										y="0.8"
										width="38.3"
										height="38.3"
									>
										<feColorMatrix
											type="matrix"
											values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
										/>
									</filter>
								</defs>
								<mask
									maskUnits="userSpaceOnUse"
									x="0"
									y="0.8"
									width="38.3"
									height="38.3"
									id="mask-2"
								>
									<g className="st1">
										<polygon
											id="path-1"
											className="st2"
											points="0,0.8 38.3,0.8 38.3,39.1 0,39.1 							"
										/>
									</g>
								</mask>
								<path
									id="Fill-1"
									className="st3"
									d="M19.1,38C9.2,38,1.1,29.9,1.1,20c0-10,8.1-18.1,18.1-18.1c10,0,18.1,8.1,18.1,18.1
						C37.2,29.9,29.1,38,19.1,38 M19.1,0.8C8.6,0.8,0,9.4,0,20c0,10.6,8.6,19.1,19.1,19.1c10.6,0,19.1-8.6,19.1-19.1
						C38.3,9.4,29.7,0.8,19.1,0.8"
								/>
							</g>
							<path
								id="Fill-4"
								className="st2"
								d="M18.1,22.8c-0.4-0.6-1-1.1-1.8-1.4l0.5-3.3c0.1,0,0.1,0,0.2,0c1.1,0,2.1-0.7,2.5-1.7l6,1.6
					c0,0.1,0,0.3,0,0.4c0,0.2,0,0.3,0.1,0.5L18.1,22.8z M27.3,16.5c-0.6,0-1.2,0.3-1.5,0.8l-6.1-1.7c0-0.1,0-0.2,0-0.4
					c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7c0,1.2,0.8,2.2,1.8,2.5l-0.5,3.3c-0.3-0.1-0.5-0.1-0.8-0.1c-2.1,0-3.8,1.7-3.8,3.8
					c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-0.5-0.1-1.1-0.3-1.5l7.4-3.9c0.3,0.5,0.9,0.8,1.5,0.8c1,0,1.8-0.8,1.8-1.8
					C29.2,17.4,28.3,16.5,27.3,16.5z"
							/>
							<path
								id="Fill-6"
								className="st2"
								d="M51.7,11.6c-1.8,0.2-3,1.3-3,1.3l0.9,1.5c0,0,2.1-1.8,5.6-1.2c1.9,0.3,3.3,1.5,3.5,5.2
					c0,0-10.6-1.5-11.4,3.9c-1,6.6,5.8,7.2,9.4,6.1c2.6-0.8,3.2-2.7,3.6-4c0.5-2,0.4-5.1,0-7.7C60,15.7,59.7,10.6,51.7,11.6
					 M56.8,26.6c-2.5,1.1-6.1,0.9-7.6-1c-1-1.2-1-4.7,2.9-5.5c4-0.8,6.6,0,6.6,0S59.4,25.5,56.8,26.6"
							/>
							<path
								id="Fill-8"
								className="st2"
								d="M119.2,11.6c-1.8,0.2-3,1.3-3,1.3l0.9,1.5c0,0,2.1-1.8,5.6-1.2c1.9,0.3,3.3,1.5,3.5,5.2
					c0,0-10.6-1.5-11.4,3.9c-1,6.6,5.8,7.2,9.4,6.1c2.6-0.8,3.2-2.7,3.6-4c0.5-2,0.4-5.1,0-7.7C127.5,15.7,127.3,10.6,119.2,11.6
					 M124.3,26.6c-2.5,1.1-6.1,0.9-7.6-1c-1-1.2-1-4.7,2.9-5.5c4-0.8,6.6,0,6.6,0S126.9,25.5,124.3,26.6"
							/>
							<path
								id="Fill-10"
								className="st2"
								d="M140.3,14.4c0,0-2.2-2.3-5.3-1c-1.4,0.6-2,2-1.7,3.1c0.3,1.3,1.7,2.2,3.4,2.6
					c3.9,1,4.9,2.5,5.2,4.3c0.4,2.7-1.7,5.4-4.9,5.4c-3.8,0-6-2.6-6-2.6l1.4-1.2c0,0,4.8,4.4,7.6,0.4c0.8-1.1,0.6-3.4-2.2-4.4
					c-3.2-1.2-5.7-1.8-6.2-4.3c-1-4.6,5.1-7.2,9.8-3.6L140.3,14.4z"
							/>
							<path
								id="Fill-12"
								className="st2"
								d="M157.9,26.1c-3.3,2-6.9,1.4-8.6,0.4c-2.8-1.7-2.8-5.3-2.8-5.3l12.8,0c0.1-0.8,0.1-2.6,0-3.4
					c-0.3-3.7-2.7-6.2-6.9-6.2c-4.4-0.1-6.9,3.4-7.4,6.5c-0.9,6,1.1,10.7,8.2,10.8c3.7,0,5.4-1.4,5.4-1.4L157.9,26.1z M152.4,13
					c6.1,0.1,5.5,6.7,5.5,6.7h-11.4C146.5,18.9,147.4,13,152.4,13z"
							/>
							<path
								id="Fill-14"
								className="st2"
								d="M111.2,24.9c1-2.3,1.3-6.9-0.2-9.7c-1.2-2.2-3.2-3.6-6.3-3.6c-3.4,0-4.9,1.3-4.9,1.3V5.7H98
					v7.5v8c0,2.2,0.7,4.3,1.9,5.7c1,1.2,3.3,2.3,6.4,1.8C108.9,28.3,110.3,27,111.2,24.9 M105.2,27.4c-4.2,0.3-5.2-3.4-5.3-4.2
					c-0.2-1.8-0.2-5-0.1-8.3c0,0,1.4-1.9,5.3-1.7c3.3,0.2,5.4,2.3,5.3,6.9C110.3,24.3,109.3,27.1,105.2,27.4"
							/>
							<path
								id="Fill-16"
								className="st2"
								d="M71.9,11.7c-3.1-0.5-5.3,0.6-6.4,1.8c-1.2,1.4-1.8,3.6-1.8,5.7v8v7.5h1.8v-7.2
					c0,0,1.5,1.3,4.9,1.3c3,0,5-1.3,6.2-3.6c1.5-2.8,1.3-7.4,0.2-9.7C76,13.4,74.7,12.1,71.9,11.7 M76.1,20.2c0.1,4.7-2,6.7-5.3,6.9
					c-3.9,0.3-5.3-1.7-5.3-1.7c-0.1-3.2-0.1-6.4,0.1-8.3c0.1-0.8,1.1-4.5,5.3-4.2C75,13.3,76,16.2,76.1,20.2"
							/>
							<path
								id="Fill-18"
								className="st2"
								d="M88.9,11.7c-3.1-0.5-5.3,0.6-6.4,1.8c-1.2,1.4-1.8,3.6-1.8,5.7v8v7.5h1.8v-7.2
					c0,0,1.5,1.3,4.9,1.3c3,0,5-1.3,6.2-3.6c1.5-2.8,1.3-7.4,0.2-9.7C92.9,13.4,91.6,12.1,88.9,11.7 M93,20.2c0.1,4.7-2,6.7-5.3,6.9
					c-3.9,0.3-5.3-1.7-5.3-1.7c0-3.2-0.1-6.4,0.1-8.3c0.1-0.8,1.1-4.5,5.3-4.2C91.9,13.3,92.9,16.2,93,20.2"
							/>
							<polygon
								id="Fill-20"
								className="st2"
								points="168.2,8.6 169.3,8.6 169.3,5.4 168.2,5.4 				"
							/>
							<polygon
								id="Fill-22"
								className="st2"
								points="163.2,28.8 164.4,28.8 164.4,25.6 163.2,25.6 				"
							/>
							<polygon
								id="Fill-23"
								className="st2"
								points="168.2,28.8 169.3,28.8 169.3,11.6 168.2,11.6 				"
							/>
							<path
								id="Fill-24"
								className="st2"
								d="M180.5,11.6c-4.3,0-7.8,3.8-7.8,8.6c0,4.7,3.5,8.6,7.8,8.6c4.3,0,7.8-3.8,7.8-8.6
					C188.2,15.4,184.8,11.6,180.5,11.6 M180.5,27.5c-3.7,0-6.6-3.3-6.6-7.3c0-4.1,3-7.3,6.6-7.3c3.7,0,6.6,3.3,6.6,7.3
					C187.1,24.3,184.1,27.5,180.5,27.5"
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

Logo.defaultProps = {
	height: 25,
	theme: `dark`,
};

Logo.propTypes = {
	height: PropTypes.number,
	theme: PropTypes.string,
};

export default Logo;
